//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { CollapseTransition } from 'vue2-transitions';
import IconArr from '~/assets/img/icons/arr-accordion.svg?inline';

export default {
  name: 'BaseAccordion',
  components: {
    CollapseTransition,
    IconArr,
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick() {
      this.$emit('click');
    },
    handleClickAfter() {
      if (this.active) return;

      this.handleClick();
    },
  },
};
